<template>
  <div class="font-modify">
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit-patient-card"
      ok-only
      centered
      size="lg"
      :title="$t('reception.edit-patient-card')"
      @ok="EditPatientCard()"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group label="Patient' Companion Name" label-for="Name">
              <b-form-input
                id="Name"
                v-model="EditForm.full_companion_name"
                placeholder="Enter Patient Name"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Phone Number" label-for="phoneNumber">
              <VuePhoneNumberInput
                v-model="EditForm.companion_phone"
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
                default-country-code="IQ"
                :error="
                  EditForm.companion_phone
                    ? isNotValid || EditForm.companion_phone[0] != 0
                    : false
                "
              />
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.next-kin-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="EditForm.next_of_kin_name"
                :placeholder="$t('reception.next-kin-name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.next-kin-phone')"
              label-for="phoneNumber"
            >
              <VuePhoneNumberInput
                v-model="EditForm.next_of_kin_phone_number"
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
                default-country-code="IQ"
                :error="
                  EditForm.next_of_kin_phone_number
                    ? isNotValid || EditForm.next_of_kin_phone_number[0] != 0
                    : false
                "
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Patient Case" label-for="Case">
              <b-form-input
                id="Case"
                v-model="EditForm.patient_case"
                placeholder="Enter Patient Case"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Diagnosis" label-for="diagnosis">
              <b-form-textarea
                id="diagnosis"
                v-model="EditForm.diagnosis"
                placeholder="Diagnosis"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Investigation" label-for="investigation">
              <b-form-textarea
                id="investigation"
                v-model="EditForm.investigation"
                placeholder="Investigation"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Examination" label-for="examination">
              <b-form-textarea
                id="examination"
                v-model="EditForm.examination"
                placeholder="Examination"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Treatment" label-for="treatment">
              <b-form-textarea
                id="treatment"
                v-model="EditForm.treatment"
                placeholder="Treatment"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="allergy" label-for="allergy">
              <b-form-textarea
                id="allergy"
                v-model="EditForm.allergy"
                placeholder="allergy"
              />
            </b-form-group>
          </b-col>

          <b-col md="3" cols="12">
            <b-form-checkbox v-model="EditForm.is_smoker">
              {{ $t("reception.smoking") }}
            </b-form-checkbox>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-checkbox v-model="EditForm.has_high_blood_pressure">
              {{ $t("reception.has-high-blood-pressure") }}
            </b-form-checkbox>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-checkbox v-model="EditForm.has_diabetes">
              {{ $t("reception.diabetic") }}
            </b-form-checkbox>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-checkbox v-model="EditForm.has_heart_disease">
              {{ $t("reception.has-heart-disease") }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <!--
   ???????? use this to disable the button for non-admin users !!!!!!!!!
    
    :disabled="
                !$store.state.auth.permissions.includes(
                  'assign-permission-to-user'
                )
              " -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-exit-room"
      ok-only
      centered
      size="lg"
      :title="$t('reception.pationt-out-room')"
      @ok="patientExitRoom()"
    >
      <b-card-text>
        <h2>{{ $t("reception.pationt-out-room-conferm") }}</h2>
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-add-to-room"
      ok-only
      centered
      size="lg"
      :title="$t('reception.pationt-add-to-room')"
      @ok="addNewRoomToPatient()"
    >
      <b-card-text>
        <b-row>
          <b-col col="12">
            <AutoComplete
              :label="$t('reception.room')"
              :placeholder="$t('reception.room')"
              v-model="patientRoom.room"
              param-query="search"
              :serializer="(val) => val"
              noSort
              endpoint="available-room"
              text-title="name"
            />
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('reception.day')">
              <b-form-input
                v-model="patientRoom.day"
                :placeholder="$t('reception.day')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-change-patient-card-type"
      ok-only
      centered
      size="lg"
      :title="$t('reception.change-patient-card-type')"
      @ok="ChangePatientCardType()"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group label="Patient Type" label-for="Type">
              <v-select
                v-model="patientCardTypeData.type"
                :options="['IN', 'OUT', 'EMERGENCY', 'CLINIC', 'LAB']"
                placeholder="Patient Type"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.loading')" />
        </div>
      </div>
    </template>
    <b-row v-else>
      <b-col style="cursor: pointer" @click="$router.go(-1)" md="12" cols="12">
        <statistic-card-horizontal
          icon=""
          :statistic="$t('common.go-back')"
          class="modify"
        />
      </b-col>
      <b-col cols="12" sm="12">
        <b-card>
          <b-row>
            <b-col lg="6">
              <h2 class="mb-2">{{ $t("reception.patient-card-detalis") }}</h2>
            </b-col>
            <b-col
              lg="2"
              v-if="$store.state.app.permissions.includes('update-patientCard')"
            >
              <b-button
                @click="show(patientCardData)"
                variant="warning"
                class="p-1 mb-1" 
                :disabled="!is_active"
                block
              >
                {{ $t("reception.edit-patient-card") }}
              </b-button>
            </b-col>
            <b-col
              lg="2"
              v-if="$store.state.app.permissions.includes('update-patientCard')"
            >
              <b-button
                @click="showCardTypeChange(patientCardData)"
                variant="warning"
                class="p-1 mb-1"
                :disabled="!is_active"
                block
              >
                {{ $t("reception.change-patient-card-type") }}
              </b-button>
            </b-col>
            <b-col
              lg="2"
              v-if="
                $store.state.app.permissions.includes('update-patientRoom') &&
                hasActiveRoom()
              "
            >
              <b-button
                @click="showExitRoomModel()"
                variant="warning"
                class="p-1 mb-1"
                :disabled="!is_active"
                block
              >
                {{ $t("reception.pationt-out-room") }}
              </b-button>
            </b-col>
            <b-col
              lg="2"
              v-if="
                $store.state.app.permissions.includes('update-patientRoom') &&
                !hasActiveRoom()
              "
            >
              <b-button
                @click="showAddRoomModel()"
                variant="success"
                class="p-1 mb-1"
                block
                :disabled="!is_active"
              >
                {{ $t("reception.pationt-add-to-room") }}
              </b-button>
            </b-col>
          </b-row>
          <div>
            <h5 class="my-2 d-flex align-items-center">
              <b>{{ $t("common.name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ getNestedProperty(patientCardData, 'patient.name') }}
              </p>
              <b-badge 
                v-if="isPatientDischarged" 
                variant="danger" 
                class="ml-2"
                style="font-size: 0.8rem;"
              >
                {{ $t("common.discharged") }}
              </b-badge>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.companion-name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ getNestedProperty(patientCardData, 'full_companion_name') }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.companion-phone") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'companion_phone') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.next-kin-name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ getNestedProperty(patientCardData, 'next_of_kin_name') }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.next-kin-phone") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ getNestedProperty(patientCardData, 'next_of_kin_phone_number') }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.card-type") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'type') }}</p>
            </h5>
            <h5 class="my-2">
              <b class="text-danger">{{ $t("reception.allergy") }}:</b>
              <p class="mx-2 d-inline text-danger">{{ getNestedProperty(patientCardData, 'allergy') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.smoking") }}:</b>
              <p class="mx-2 d-inline">
                {{ !getNestedProperty(patientCardData, 'is_smoker') ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.diabetic") }}:</b>
              <p class="mx-2 d-inline">
                {{ !getNestedProperty(patientCardData, 'has_diabetes') ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.heart-disease") }}:</b>
              <p class="mx-2 d-inline">
                {{ !getNestedProperty(patientCardData, 'has_heart_disease') ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.hypertension") }}:</b>
              <p class="mx-2 d-inline">
                {{ !getNestedProperty(patientCardData, 'has_high_blood_pressure') ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.weight") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'weight') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.height") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'height') }}</p>
            </h5>

            <h5 class="my-2">
              <b>{{ $t("reception.room") }}:</b>
              <p class="mx-2 d-inline">
                {{ roomName }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.patient-case") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'patient_case') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.diagnosis") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'diagnosis') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.investigation") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'investigation') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.treatment") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'treatment') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.examination") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'examination') }}</p>
            </h5>
            <!-- <h5 class="my-2">
              <b>{{ $t('reception.patient-case-detalis') }}:</b>
              <p class="mx-2 d-inline">
                {{ patientCardData.patient_case_details }}
              </p>
            </h5> -->
          </div>

          <hr class="invoice-spacing" />
          <h2 class="my-2">{{ $t("reception.patient-updates") }}</h2>
          <div>
            <h5 class="my-2">
              <b>{{ $t("reception.date-of-last-update") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'updated_at') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.patient-info-created-at") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'created_at') }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.card-no") }}:</b>
              <p class="mx-2 d-inline">{{ getNestedProperty(patientCardData, 'card_no') }}</p>
            </h5>
          </div>

          <b-row>
            <b-col cols="12" md="3"></b-col>
            <b-col cols="12" md="6">
              <!-- <DoctorNotesBox
                v-if="
                  patientCardData.type == 'IN' ||
                  patientCardData.type == 'EMERGENCY' ||
                  patientCardData.type == 'CLINIC' ||
                  patientCardData.type == 'OUT'
                "
              /> -->
            </b-col>
            <b-col cols="12" md="3"></b-col>
          </b-row>
        </b-card>

        <PateintCardTest
          :patientCardId2="$route.params.id"
          :patientCardId="getNestedProperty(patientCardData, 'id')"
          v-if="$store.state.app.permissions.includes('get-patientCardTest')"
          :disabled="!is_active"
        />
      </b-col>
    </b-row>
    <!-- <PatentCardSurgery
      :patientCardId="patientCardData.id"
      :patientSurgery="patientCardData.surgeries[0]"
      :doctors="patientCardData.doctors"
      v-if="
        patientCardData.type == 'IN' &&
        ($store.state.app.permissions.includes('get-patientCardSurgery') ||
          $store.state.app.permissions.includes('store-patientCardSurgery'))
      "
    /> -->
    <PatientEmergency
      :patientCardId="getNestedProperty(patientCardData, 'id')"
      v-if="patientCardData.type == 'EMERGENCY'"
      :disabled="!is_active"
    />
    <PatientDrug
      :patientCardId="getNestedProperty(patientCardData, 'id')"
      v-if="
        patientCardData.type == 'IN' ||
        patientCardData.type == 'EMERGENCY' ||
        patientCardData.type == 'CLINIC' ||
        patientCardData.type == 'OUT'
      "
      :disabled="!is_active"
    />
    <PatientCardRadiology
      :patientCardId="getNestedProperty(patientCardData, 'id')"
      v-if="
        $store.state.app.permissions.includes('get-patientCardRadiology') &&
        patientCardData.type == 'IN'
      "
      :disabled="!is_active"
    />

    <ScannedAttachments
      :patientCardId="getNestedProperty(patientCardData, 'id')"
      v-if="patientCardData.type == 'CLINIC'"
    />
    <!-- <PatientOutClinicInvoice
      :patientCardId="patientCardData.id"
      v-if="
        ($store.state.app.permissions.includes('get-invoiceOutClinic') &&
          patientCardData.type == 'OUT') ||
        patientCardData.type == 'EMERGENCY' ||
        patientCardData.type == 'CLINIC'
      "
    /> -->

    <!-- <SurgeryInsuranceInvoice
      :patientCardId="patientCardData.id"
      v-if="
        $store.state.app.permissions.includes('get-invoiceInsuranceSurgery') &&
        patientCardData.type == 'IN'
      "
    /> -->
    <Attachments
      v-if="
        patientCardData.type == 'LAB' ||
        patientCardData.type == 'IN' ||
        patientCardData.type == 'OUT'
      "
      :patientCardId="getNestedProperty(patientCardData, 'id')"
    />
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BSpinner,
  BFormCheckbox,
  BBadge,
} from "bootstrap-vue";
import ReceptionHistoryCard from "@/components/reception/ReceptionHistoryCard";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PateintCardTest from "@/views/lab/PatientCardTest.vue";
import PatentCardSurgery from "@/views/surgery/PatientSurgery.vue";
import PatientCardRadiology from "@/views/radiology/PatientCardRadiology.vue";
import PatientOutClinicInvoice from "@/views/Reception/PatientOutClinicInvoice.vue";
import SurgeryInsuranceInvoice from "@/views/surgery/SurgeryInsuranceInvoice.vue";
import PatientEmergency from "@/views/emergency/PatientEmergency.vue";
import PatientDrug from "@/views/pharmacy/PatientDrug.vue";
import Attachments from "./Attachments.vue";
import ScannedAttachments from "@/views/Clinic/ScannedAttachments.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import VueHtml2pdf from "vue-html2pdf";
import patient from "@/store/patient";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BSpinner,
    BCard,
    BCardText,
    Attachments,
    BButton,
    BFormCheckbox,
    BBadge,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    StatisticCardHorizontal,
    AutoComplete,
    vSelect,
    ToastificationContent,
    PateintCardTest,
    PatentCardSurgery,
    PatientCardRadiology,
    PatientOutClinicInvoice,
    SurgeryInsuranceInvoice,
    PatientEmergency,
    VuePhoneNumberInput,
    PatientDrug,
    ScannedAttachments,
    VueHtml2pdf,
  },
  data() {
    return {
      loading: false,
      params: {
        form: {},
        path: "",
      },
      EditForm: {
        full_companion_name: "",
        next_of_kin_name: "",
        next_of_kin_phone_number: "",
        companion_phone: "",
        patient_case: "",
        diagnosis: "",
        investigation: "",
        treatment: "",
        examination: "",
        type: "",
        allergy: "",
        patient_id: "",
        _method: "PUT",
        has_diabetes: 0,
        has_high_blood_pressure: 0,
        has_heart_disease: 0,
        is_smoker: 0,
      },
      patientCardTypeData: {
        id: "",
        type: "",
      },
      patientCardData: {},
      patientTest: {},
      patientTestForm: {
        patient_card_id: "",
        tests: [],
        _method: "PUT",
      },
      typeList: [
        {
          text: "Type 1",
          value: "0",
        },
        {
          text: "Type 2",
          value: "1",
        },
      ],
      patientRadiology: {},
      patientRadiologyForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
        _method: "PUT",
      },
      patientRoom: {
        room: {},
        day: 1,
      },
      isPatientDischarged: false,
      is_active: this.$route.params.is_active == true ,
    };
  },
  mounted() {
    this.getPatientCard();
  },

  computed: {
    paddedPatientNo() {
      const patientNo = this.patientCardData.patient.patient_no.toString();
      const paddedNo = patientNo.padStart(7, "   ");
      return paddedNo.split("").reverse();
    },
    roomName() {
      const hasroom = this.patientCardData && this.patientCardData.patient_room && this.patientCardData.patient_room.find(
        (x) => !x.out_room_date
      );
      console.log(hasroom);
      return hasroom ? hasroom.room.name : "";
    },
  },

  methods: {
    show(item) {
      this.EditForm.id = item.id;
      this.EditForm.full_companion_name = item.full_companion_name;
      this.EditForm.companion_phone = item.companion_phone;
      this.EditForm.patient_case = item.patient_case;
      this.EditForm.patient_id = item.patient_id;
      this.EditForm.diagnosis = item.diagnosis;
      this.EditForm.investigation = item.investigation;
      this.EditForm.treatment = item.treatment;
      this.EditForm.allergy = item.allergy;
      this.EditForm.is_smoker = item.is_smoker === 1 ? true : false;
      this.EditForm.has_diabetes = item.has_diabetes === 1 ? true : false;
      this.EditForm.has_heart_disease =
        item.has_heart_disease === 1 ? true : false;
      this.EditForm.has_high_blood_pressure =
        item.has_high_blood_pressure === 1 ? true : false;

      this.EditForm._method = "PUT";
      this.$bvModal.show("modal-edit-patient-card");
    },
    addNewRoomToPatient() {
      const data = {
        patient_card_id: this.patientCardData.id,
        room_id: this.patientRoom.room.id,
        price: this.patientRoom.room.price,
        days: this.patientRoom.day,
      };
      (this.params.form = data),
        (this.params.path = `/patientRoom/`),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.getPatientCard();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Exit room",
                variant: "success",
              },
            });
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Add room field",
                variant: "danger",
              },
            });
          });
    },
    patientExitRoom() {
      const activeRoom = this.patientCardData.patient_room.find(
        (x) => !x.out_room_date
      );
      (this.params.form = {}),
        (this.params.path = `/out-patient-from-room/${activeRoom.id}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.getPatientCard();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Exit room",
                variant: "success",
              },
            });
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Exit room field",
                variant: "danger",
              },
            });
          });
    },
    hasActiveRoom() {
      const hasroom = this.patientCardData && this.patientCardData.patient_room && this.patientCardData.patient_room.find(
        (x) => !x.out_room_date
      );
      return hasroom ? true : false;
    },

    showExitRoomModel() {
      this.$bvModal.show("modal-exit-room");
    },
    showAddRoomModel() {
      this.$bvModal.show("modal-add-to-room");
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    printInpatientForm() {
      this.$refs.currentPatientPdf.generatePdf();
    },

    showCardTypeChange(item) {
      this.patientCardTypeData.type = item.type;
      this.patientCardTypeData.id = item.id;
      this.$bvModal.show("modal-change-patient-card-type");
    },

    ChangePatientCardType() {
      (this.params.form = this.patientCardTypeData),
        (this.params.path = `/change-card-type/patientCard/${this.patientCardTypeData.id}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.getPatientCard();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Card Edited",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },

    EditPatientCard() {
      (this.params.form = this.EditForm),
        (this.params.path = `/patientCard/${this.EditForm.id}`),
        this.$store
          .dispatch("update", this.params)
          .then((response) => {
            this.getPatientCard();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Card Edited",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },

    async getPatientCard() {
      this.loading = true;
      
      // Get route parameters
      const patientId = this.$route.params.id;
       const cardId = this.$route.params.card_id;
      
      try {
         if (this.is_active == true) {
          // Patient is active, get the specific card
          await this.getPatient(
            `patientCard/${cardId}?include=patient,doctors,surgeries,patientRoom`
          );
           this.isPatientDischarged = false;
        } else {
          // Patient is not active (discharged), get the specific card
          await this.getPatient(
            `patientCard/${cardId}?include=patient,doctors,surgeries,patientRoom`
          );
           this.isPatientDischarged = true;
        }
        
      } catch (error) {
        console.error('Error fetching patient card:', error);
        // Display error toast notification
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t('common.error'),
            variant: "danger",
            text: this.$t('common.error-fetching-data'),
            icon: "XIcon"
          },
        });
        // Fallback: try to get patient cards by patient ID
      
      }
      
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientCardData = this.all_data;
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

.start-box {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0 1rem;
  position: absolute;
  right: 1%;
  top: -13.5%;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
.font-modify {
  letter-spacing: normal !important;
}
</style>
